"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.emitted = exports.processingEmission = exports.pendingEmission = exports.pendingInspection = void 0;
var QuotationStatus_1 = require("../models/QuotationStatus");
var quotationStatus_1 = require("../constants/quotationStatus");
/**
 * Possible status
 */
exports.pendingInspection = __assign(__assign({}, QuotationStatus_1.makeEmptyQuotationStatus()), { id: quotationStatus_1.PENDING_INSPECTION });
exports.pendingEmission = __assign(__assign({}, QuotationStatus_1.makeEmptyQuotationStatus()), { id: quotationStatus_1.PENDING_EMISSION });
exports.processingEmission = __assign(__assign({}, QuotationStatus_1.makeEmptyQuotationStatus()), { id: quotationStatus_1.PROCESSING_EMISSION });
exports.emitted = __assign(__assign({}, QuotationStatus_1.makeEmptyQuotationStatus()), { id: quotationStatus_1.EMITTED });
//# sourceMappingURL=mockQuotationStatus.js.map